import useTranslation from '@app/hooks/use-translation';
import { QmAppealStatuses } from '@app/interfaces/qm-module/qm-appellations/qm-appellations.type';
import React, { FC } from 'react';
// красный , зеленый , серый
// eslint-disable-next-line
export const colorsForAppealBorder = ['#FFA7A7', '#A3C585', '#5d697e'];
const AppealStatusForRecord: FC<{ status: QmAppealStatuses }> = ({ status }) => {
  const { t } = useTranslation('components.audio.monitoring');

  return (
    <div
      style={{
        background:
          status === 'ACCEPTED'
            ? colorsForAppealBorder[1]
            : status === 'DECLINED' || status === 'CLOSED'
            ? colorsForAppealBorder[2]
            : colorsForAppealBorder[0],
      }}
      className="p-[2px_8px] text-[12px] text-white rounded-[4px]"
    >
      {t(`appeal_statuses.${status}`)}
    </div>
  );
};

export default AppealStatusForRecord;
